import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { DataStoreService } from 'src/app/services/dataStore/data-store.service';
import { DataStore } from 'src/app/models/responses/dataStoreResponse';
import { DatastoreFormComponent } from './datastore-form/datastore-form.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomModalComponent } from 'src/app/components/modals/custom-modal/custom-modal.component';
import { IndexFormComponent } from './index-form/index-form.component';
import { DesignDataFormComponent } from './design-data-form/design-data-form.component';
import { NodeService } from 'src/app/services/node/node.service';
import { Node } from 'src/app/models/responses/nodeResponse';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-datastore',
  templateUrl: './datastore.component.html',
  styleUrls: ['./datastore.component.scss']
})
export class DatastoreComponent implements OnInit {

  displayedColumns: string[] = ['icon', 'dataStoreId', 'name', 'description', 'node', 'universe', 'collection', 'action'];
  displayedColumnsName: string[] = [this.translate.instant("Common.Icon"), "DataStore Id", this.translate.instant("DataStorePage.Name"), this.translate.instant("DataStorePage.Description"), this.translate.instant("DataStorePage.Node"), this.translate.instant("DataStorePage.Universe"), this.translate.instant("DataStorePage.Collection"), this.translate.instant("DataStorePage.Action")];
  // dataStores: DataStore[] = [];
  nodes: Node[] = []
  actionButtonsList: { icon: string, text: string, actionFunction: Function }[] = [{ icon: 'hash', text: 'Edit', actionFunction: (element) => this.openIndexForm(element) }]


  @Input() dataStores: DataStore[] = [];
  @Input() getDataStores: boolean = true
  @Input() addButtonText: string = 'DataStorePage.AddButton'
  @Input() pageSize: number = 10
  @Input() displayTitle: boolean = true
  @Output() openModalFunc: EventEmitter<any> = new EventEmitter()
  @Output() getDataStoreFunc: EventEmitter<any> = new EventEmitter()

  constructor(
    private spinner: NgxSpinnerService,
    private dataStoreService: DataStoreService,
    private nodeService: NodeService,
    private modalService: ModalService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.getDatastores()
  }

  getDatastores() {
    if (this.getDataStores) {
      this.dataStoreService.getDatasources().subscribe(result => {
        this.dataStores = result;
        this.dataStores.map(d => {
          d.icon = "/BussionImages/Pictures/DataStore.png";
          return d;
        })
      });
    }
  }

  deleteDataStoreComponent(dataStore: DataStore) {
    this.modalService.openDeleteConfirm().subscribe(result => {
      if (result === true) {
        this.spinner.show();
        this.dataStoreService.deleteDataStore(dataStore).subscribe(result => {
          this.spinner.hide();
          if (this.getDataStores) {
            this.getDatastores();
          } else {
            this.getDataStoreFunc.emit()
          }
        });
      }
    });
  }

  openDataStoreComponent(event: any) {
    if (!this.getDataStores) {
      this.openModalFunc.emit(event);
    } else {
      let data = {
        type: event.type as string,
        dataStore: event.data as DataStore
      }
      this.modalService.openModal(data, DatastoreFormComponent, 'auto', '1000px').subscribe(result => {
        if (result === true) {
          this.getDatastores();
        }
      });
    }
  }

  getNodes(): Observable<any[]> {
    return this.nodeService.getNodes().pipe(
      tap(res => {
        if (res) {
          this.nodes = res;
        }
      })
    );
  }

  openDesignDataForm(event: any) {
    const openModal = () => {
      const data = {
        type: event,
        dataStores: this.dataStores,
        nodes: this.nodes
      };
      this.modalService.openModal(data, DesignDataFormComponent, '90%', '100%').subscribe(result => {
        if (result === true) {
          this.getDatastores();
        }
      });
    };
  
    if (this.nodes.length <= 0) {
      this.getNodes().subscribe(() => {
        openModal();
      });
    } else {
      openModal();
    }
  }
  


  openIndexForm(element) {

    this.modalService.openModal({ dataStore: element }, IndexFormComponent, '70%', '50%', 'overflow-hidden').subscribe(result => {
      if (result === true) {
        this.getDatastores();
      }
    });
  }


}
